export default "__VITE_ASSET__3dfddc11__"